import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import '@hotmart-org-ca/cosmos/dist/form/form.css';
import '@hotmart-org-ca/cosmos/dist/form/input-custom.css';
import '@hotmart-org-ca/cosmos/dist/form/input-checkbox.css';
import clsx from 'clsx';
export function Checkbox({ label = '', labelClassName, indeterminate = false, ...props }) {
    const inputRef = useRef(null);
    useEffect(function setIndeterminate() {
        if (inputRef.current)
            inputRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return (_jsxs("div", { className: "hot-form--custom hot-form--checkbox -mt-[2px]", children: [_jsx("input", { ref: inputRef, ...props, type: "checkbox", className: "hot-form__input" }), _jsxs("label", { className: clsx('hot-form__label', labelClassName), htmlFor: props.id, children: [label || _jsx(_Fragment, { children: "\u200B" }), " "] })] }));
}
